import { render, staticRenderFns } from "./FreightBillCredit.vue?vue&type=template&id=1c73eecf"
import script from "./FreightBillCredit.vue?vue&type=script&lang=js"
export * from "./FreightBillCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c73eecf')) {
      api.createRecord('1c73eecf', component.options)
    } else {
      api.reload('1c73eecf', component.options)
    }
    module.hot.accept("./FreightBillCredit.vue?vue&type=template&id=1c73eecf", function () {
      api.rerender('1c73eecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillCredit.vue"
export default component.exports